
import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import images from "./images";

export const convertRemToPixels = (rem) => {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}


export const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        minWidth: 275,
    },
    customContainer: {
        height: "100vh",
    },
   
}));

export default useStyles